var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSpinner = function SvgSpinner(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "#fff",
    viewBox: "0 0 25 25"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.2,
    d: "M4.5 12.5a8 8 0 1 0 8-8"
  })));
};
export default SvgSpinner;